export default __webpack_public_path__ + "static/media/Shivani.d8a82048.jpg";